<h1 mat-dialog-title>Confirmation</h1>
<div mat-dialog-content>
    <p class="mt-4 mb-5">{{ data.text }}</p>
    <div mat-dialog-actions class="justify-content-end">
        <button class="btn btn-secondary mr-2" (click)="onNoClick()">Cancel</button>
        <button class="btn btn-primary" [mat-dialog-close]="true">Confirm</button>
    </div>
</div>